import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip,
} from "@mui/material";

const fmt = (n) => (n >= 1000 ? `₹${(n / 1000).toFixed(1)}K` : `₹${n}`);

const Product = ({ product_name, sku_code, brand }) => (
  <Box>
    <Typography fontSize={13} fontWeight={500}>{product_name}</Typography>
    <Typography fontSize={11} color="text.secondary">
      {sku_code} · {brand}
    </Typography>
  </Box>
);

export default function DeadStock({ data = [] }) {
  const total = data.reduce((a, x) => a + x.inventory_value, 0);

  return (
    <Box mb={3}>
      <Box display="flex" justifyContent="space-between" mb={1.5}>
        <Box display="flex" gap={1} alignItems="center">
          <Box width={3} height={16} bgcolor="#E24B4A" borderRadius={1} />
          <Typography fontSize={13.5} fontWeight={500}>
            Dead stock
          </Typography>
        </Box>

        <Typography fontSize={11.5} color="error.main">
          {data.length} SKUs · {fmt(total)} stuck
        </Typography>
      </Box>

      <Paper
        variant="outlined"
        sx={{
          border: "1px solid var(--color-border-danger)",
        }}
      >
        <Table size="small">
          <TableHead sx={{ background: "var(--color-background-secondary)" }}>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Stock</TableCell>
              <TableCell>Last sale</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((r) => (
              <TableRow
                key={r.sku_code}
                sx={{ background: "rgba(226,75,74,.04)" }}
              >
                <TableCell><Product {...r} /></TableCell>
                <TableCell>{r.inventory_units}</TableCell>
                <TableCell sx={{ color: "error.main", fontWeight: 500 }}>
                  {r.days_since_last_sale}d ago
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: "error.main" }}>
                  {fmt(r.inventory_value)}
                </TableCell>
                <TableCell>
                  <Chip
                    label={r.action}
                    size="small"
                    sx={{
                      background: "var(--color-background-danger)",
                      color: "var(--color-text-danger)",
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}